import { gql } from "@apollo/client";

export const getOrganizationsAvailableForLensSpaceCreation = gql`
    query getOrganizationsAvailableForLensSpaceCreation {
        getMyLensesOrganizationsAvailableForLensSpaceCreation {
            organizationsList {
                id
                name
            }
        }
    }
`;
